module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "afisha-logo",
    attrs: {
      "href": "https://www.afisha.ru/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('afisha logo')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/afisha.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "megafon-logo",
    class: {
      'megafon-logo-color': _vm.GET_LOAD
    },
    attrs: {
      "href": "https://www.megafon.ru/go/roaming_goodbye?utm_source=afisha&utm_campaign=fed_flight_www-b2c_afisha-special-project-roaming-goodbye-2-jul-2018_rf&utm_medium=ag-media_media_logo_logo_cpc__&utm_content=&utm_term",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('megafon logo')
      }
    }
  }, [_c('megafon')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94332682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/headerApp.vue
// module id = 506
// module chunks = 1